import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';
import LegacyEditor from 'components/LegacyEditor';

import { useErrorHandler } from 'lib';
import { PageEditForm_page$key } from '__generated__/PageEditForm_page.graphql';
import { PageEditFormMutation } from '__generated__/PageEditFormMutation.graphql';

type FormFields = {
  name: string;
  text: string;
};

type Props = {
  page: PageEditForm_page$key;
};

const PageEditForm: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, name, text } = useFragment(
    graphql`
      fragment PageEditForm_page on Page {
        id
        name
        text
      }
    `,
    props.page
  );

  const [update, updating] = useMutation<PageEditFormMutation>(graphql`
    mutation PageEditFormMutation($id: ID!, $input: UpdatePageInput!) {
      updatePage(id: $id, input: $input) {
        ...EntitySidebar_entity
        ...PageEditForm_page
      }
    }
  `);

  const initial = {
    name,
    text: text ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormFields) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="pageEdit">
          <Section id="main" title="Bendra informacija">
            <Stack spacing={4}>
              <TextField fullWidth name="name" label="Pavadinimas" />
              <LegacyEditor name="text" label="Tekstas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default PageEditForm;
